<template >
  <div
    id="container"
    :class="{'back': isShow}"
    v-show="isShow"
  >
    <canvas id="the-canvas">
    </canvas>
    <!-- / / 添加关闭pdf功能-->
    <span :class="{'close':isShow}" @click="closePdf">X</span>
      <div
        class="foot flex-cc"
        v-if="pdfDoc"
      >
        <div
          class="left"
          @click="onPrevPage"
          v-if="pageNum>1"
        >上一页</div>
        <div
          class="right"
          @click="onNextPage"
          v-if="pageNum<pdfDoc.numPages"
        > 下一页 </div> </div>
  </div>
</template>
<script>
  import PDFJS from 'pdfjs-dist'
  export default {
    data () {
      return {
        isShow:
          false,
        // 通过该属性动态添加类，让pdf显示或隐藏
        pdfDoc: null,
        // 可以打印发现是一个对象，里面有页数信息等
        pageNum: 1,
        pageRendering: false,
        pageNumPending: null,
        scale: 0.9
      }
    },
    methods: {
      closePdf () {
        this.isShow = false
      },
      showPDF (url) {
        this.isShow = true
        let _this = this
        PDFJS.getDocument(url).then(function (pdf) {
          _this.pdfDoc = pdf
          _this.renderPage(1)
        })
      },
      renderPage (num) {
        this.pageRendering = true
        let _this = this
        this.pdfDoc.getPage(num).then(function (page) {
          var viewport = page.getViewport(_this.scale)
          let canvas = document.getElementById('the-canvas')
          canvas.height = viewport.height
          canvas.width = viewport.width // Render PDF page into canvas context
          var renderContext = {
            canvasContext: canvas.getContext('2d'),
            viewport: viewport
          }
          var renderTask = page.render(renderContext) // Wait for rendering to finish
          renderTask.promise.then(function () {
            _this.pageRendering = false
            if (_this.pageNumPending !== null) {
              // New page rendering is pending
              this.renderPage(_this.pageNumPending)
              _this.pageNumPending = null
            }
          })
        })
      },
      queueRenderPage (num) {
        if (this.pageRendering) {
          this.pageNumPending = num
        } else {
          this.renderPage(num)
        }
      },
      onPrevPage () {
        if (this.pageNum <= 1) {
          return
        }
        this.pageNum--
        this.queueRenderPage(this.pageNum)
      },
      onNextPage () {
        if (this.pageNum >= this.pdfDoc.numPages) {
          return
        }
        this.pageNum++
        this.queueRenderPage(this.pageNum)
      }
    }
  }
</script>
<style lang="less">
.back {
  background-color: rgba(0, 0, 0, 0.788);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
  padding: 20px 0;
  z-index: 100;
  overflow: scroll;
  box-sizing: border-box;
}
.close {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 200;
  color: #fff;
  cursor: pointer;
}
#the-canvas {
  margin-top: 20px;
  width: 90vw;
  // height: 90vh;
}
.foot {
  position: absolute;
  width: 100%;
  bottom: 20px;
  left: 50%;
  box-sizing: border-box;
  transform: translate(-50%, 0);
  color: #fff;
  .left {
    height: 20px;
    padding: 0 20px;
    line-height: 20px;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    margin: 0 30px;
  }
  .right {
    height: 20px;
    padding: 0 20px;
    line-height: 20px;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    margin: 0 30px;
  }
}
</style>
